export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";